<style>
  .ivu-modal-footer{border: none;}
  .ivu-select-multiple{height: 32px;}
  .ivu-select-selection{z-index:100;}
</style>
<template>
  <div>
    <page-head
      :title="title"
      :btn-list="btnList"
      :show-back="false"
      @handleBtn="handleBtn"
    ></page-head>
    <div class="content">
      <div class="search">
        <i-form ref="search" :model="query2">
          <row :gutter="80">
            <i-col span="6">
              <form-item label="婴儿名称" prop="babyName">
                <Input
                  v-model="query2.babyName"
                  clearable
                  placeholder="请输入"
                />
              </form-item>
            </i-col>
            <i-col span="6">
              <form-item label="婴儿性别" prop="babyGender">
                <Select v-model="query2.babyGender" clearable>
                  <Option
                    v-for="item in schoolTypelist"
                    :key="item.index"
                    :value="item.type"
                    :label="item.type"
                  ></Option>
                </Select>
              </form-item>
            </i-col>
            <i-col span="6">
              <form-item label="医疗机构" prop="medicalDept">
                <Input
                  v-model="query2.medicalDept"
                  clearable
                  placeholder="请输入"
                />
              </form-item>
            </i-col>
            <i-col span="6">
              <form-item label="婴儿籍贯" prop="babyRegister">
                <Input
                  v-model="query2.babyRegister"
                  clearable
                  placeholder="请输入"
                />
              </form-item>
            </i-col>
           </row>
        </i-form>

      </div>
      <div class="table-data">
        <div class="bottomtable">
          <i-table
            :columns="tableHeader2"
            :border="true"
            :loading="isLoading"
            :data="tableData2"
            stripe
            ref="table"
          >
            <template slot-scope="{ row, index }" slot="action2">
              <!-- <span class="action">[删除]</span> -->
              <span class="action"  @click="handleschoolDetail(row)">[查看]</span>
              <!-- <span @click.stop="handleClickDetail(row, 'detail')" class="action">[详情]</span> -->
            </template>

          </i-table>
        </div>
        <div class="page">
          <page
            :total="total2"
            :current="pageNum2"
            @on-change="pageChange2"
            show-total
          />
        </div>
      </div>



    </div>
  </div>
</template>



<script>
import pageHead from "../../../components/head";
import PreviewImg from "../../../components/previewImg";
import store from "../../../store/index";
import api from "../../../api/index";
const {
  newborn,
  downloadNewborn
} = api;

export default {
  name: "schoollist",
  components: {
    pageHead
  },

  data() {
    return {
      btnList: [
        {name: "查询",type: "search"},
        {name: "重置",type: "refresh"},
      ],
      iseducation:false,
      modal1:false,
      tapidnex:3,
      checkMsg: "",
      checkedId: "",
      showCheckMsg: false,
      modalTitle: "",
      schoolIspubliclist:[
        {index: 1,type: "公办"},
        {index: 2,type: "民办"},
      ],
      schoolTypelist:[
        {index: '男',type: "男"},
        {index: '女',type: "女"},
      ],
      schoolRegionlist:[
        {index: 0,type: "市直"},
        {index: 1,type: "油田"},
        {index: 2,type: "开发区"},
        {index: 3,type: "华龙区"},
        {index: 4,type: "示范区"},
      ],
      deptNamelist:[],
      deptNamelist1:[],
      query2: {
       	"babyName": "",
       	"babyGender": "",
        'medicalDept':'',
        "babyRegister":""
      },


      shoolquery:{
        schoolId:''
      },
      estateUnitNO: "",
      estateUnitNOList: [],
      status: "",
      info: {},
      time: "",
      isLoading: false,
      isBtbLoading: false,
      pageNum2: 1,
      pageSize2: 10,
      total2: 0,
      title: "新生儿",
      tableHeader2: [
        // {type: "selection",width:70,align: "center",},
        // {title: "序号",key: "id",width:100,},
        {title: "婴儿姓名",key: "babyName",width:120},
        {title: "婴儿性别",key: "babyGender",width:110},
        {title: "婴儿生日",key: "babyBirthday",width:110},
        {title: "医疗机构名称",key: "medicalDept",width:150},
        {title: "母亲姓名",key: "momName",width:110},
        {title: "母亲联系电话",key: "momTel",width:180},
        {title: "父亲姓名",key: "dadName",width:110},
        {title: "父亲联系电话",key: "dadTel",width:180},
        {title: "婴儿籍贯",key: "babyRegister"},

        {title: "操作",slot: "action2",width:100,},
      ],
      tableHeader3: [
        {title: "教育局序号",key: "id",width:90,},
        {title: "教育局名称",key: "schoolName",width:220},
        {title: "行政区域",key: "schoolRegion",},
        {title: "教育局地丘号",key: "schoolLandNum",},
        {title: "关联部门",key: "deptName",},
        {title: "教育局地址",key: "schoolAddress",},
        {title: "描述",key: "schoolInfo",},
        {title: "操作",slot: "action3",minWidth:46,},
      ],
      tableData: [],
      tableData1: [],
      tableData2: [],
      tableData3: [],
      selectedList: [],
      selectedListid:[],
      header: {
        token: window.sessionStorage.getItem("token"),
      },
    };
  },
  methods: {
    handleBtn(type){
      if (type == "search") {
        this.pageNum2 = 1;
        this.getLandTransferList2();
      }else  if (type == "refresh") {
        this.pageNum2 = 1;
        this.query2={
         "babyName": "",
         "babyGender": "",
         'medicalDept':'',
         'babyRegister':''
        }
        this.getLandTransferList2();
      }
    },
    pageChange2(val) {
      this.pageNum2 = val;
      this.getLandTransferList2();
    },

    async getLandTransferList2() {
      this.isLoading = true;
      let data={
        pageNum:this.pageNum2,
        pageSize:this.pageSize2,
        ...this.query2
      }
      try {
        console.log(newborn)
        this.$get(newborn,{
            pageNum:this.pageNum2,
            pageSize:this.pageSize2,
            ...this.query2})
          .then(res => {
            if(res.code == 1){
                this.tableData2 = res.rows;
                this.total2 = res.total;
            } else {
                this.$Message.error(res.message);
            }
          })
          .catch(e => {
            this.$Message.error("获取列表失败");
          });
		//     let url=newborn
        // let res = await this.$get(url);
        // if(res.rows&&res.rows.length>0){
        //   let list = res.rows[0].list.map((item) => ({
        //     ...item,
        //     schoolIspublic:item.schoolIspublic==2?'民办':'公办'
        //   }));
        //   console.log(list);
        //   this.tableData2 = list;
        //   this.total2 = res.rows[0].total;
        // }

      } finally {
        this.isLoading = false;
      }
    },
    handleschoolDetail(row) {
        this.isLoading = true;
        // window.open(`${downloadNewborn}?id=${row.id}$token=${store.state.access_token}`);
        this.$get(downloadNewborn,{id:row.id})
          .then(res => {
            if(res.code == 1){
                window.open(res.newPrimaryKeys.attachmentDetail.attachmentUrl)
                this.isLoading = false;
            } else {
                this.$Message.error(res.message);
                this.isLoading = false;
            }
          })
          .catch(e => {
            this.$Message.error("获取列表失败");
            this.isLoading = false;
          });
    }
    

  },

  created() {
    this.getLandTransferList2()
  },
  mounted() {},
};
</script>

<style  scoped lang="less">
.content {
  margin:0 20px 20px 20px;
}
.toptab{width: 100%;display: flex;display: -webkit-flex;justify-content: space-between;border-bottom: solid 1px #EEEEEE;}
.toptableft{width: 100%;display: flex;display: -webkit-flex;}
.toptableft span{width: 86px;height: 32px;text-align: center;line-height: 32px;font-size: 16px;}
.bottombtn{width:150px;text-align: center;height:32px;line-height:32px;font-size: 16px;color: #FFFFFF;border-radius: 6px;background: #0097FF;}
.activetap{background: #FF7B44;color: #FFFFFF;border-radius: 6px 6px 0 0;}
.nomaltap{background: #FFFFFF;color: #666666;border-radius: 6px 6px 0 0;border: solid 1px #EEEEEE;}
.search {width: 100%;background-color: white;border-radius: 5px;padding: 20px;margin-bottom: 20px;}

.label {width: 100px;}
.time {width: 100%;}
.bottomtable{width: 100%;padding:20px;}
.table-data {
  width: 100%;
  background-color: white;
  border-radius: 5px;
  min-height: calc(100vh - 320px);
  .page {width: 100%;display: flex;justify-content: center;}
  .success {color: #ff7b44;}
  .action {color: #5e6d94;cursor: pointer;margin-right: 10px;}
}

.statistics {padding: 10px 0;text-align: right;}

.estateTitle {color: #ff7b44;font-weight: bold;}

.estateNO {color: #ff7b44;font-weight: 400;background: #ffefe9;margin: 0 15px 10px 0;}
.topformbox{width: 100%;background: #F8F8F8;height: 80px;border-radius: 4px 4px 0px 0px;display: flex;display: -webkit-flex;align-items: center;justify-content: space-between;}
.topformbox .ivu-form{width: 100%;height: 80px;display: flex;display: -webkit-flex;align-items: center;}
.topformbox .ivu-form .ivu-form-item{margin: 0;width: 360px;}
.topformbox .ivu-form .ivu-form-item:nth-child(1){margin-left: 21px;}
.topformboxright{height: 80px;display: flex;display: -webkit-flex;align-items: center;}
.topformboxright span:nth-child(1){width: 92px;height: 28px;background: #FF7943;border-radius: 4px;text-align: center;line-height: 28px;font-size: 14px;color: #FFFFFF;margin-right: 20px;}
.topformboxright span:nth-child(2){width:120px;height: 28px;background: #F9FAFA;border: 1px solid #DEDEDE;border-radius: 4px;text-align: center;line-height: 28px;font-size: 14px;color: #4B4B4B;margin-right: 20px;}

.schoolbox{width: 100%;}


</style>
